<template>
  <div class="industry-tree" v-loading="loading">
    <div class="industry" v-if="showGroup && tenantGroups.length > 0">
      <el-select v-model="tenantGroup.id" placeholder="请选择行业" @change="tenantGroupChange" style="width: 100%;" class="text-center" popper-class="option-center">
        <el-option v-for="item in tenantGroups" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="tree-box">
      <el-tree :expand-on-click-node="false" :data="datas" :props="defaultProps" class="file-tree" node-key="uuid" :default-expand-all="true" ref="tree" :filter-node-method="filterNode">
        <div slot-scope="{data}" class="tree-items" @click.stop="selectTreeItem(data)" :class="{ 'active': data.id == currentItem.id }">
          <span class="name" :title="data.name">{{ data.name }}</span>
          <span class="dr"><i class="el-icon-right"></i></span>
        </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: "",
    reset: "",
    showGroup: {
      type: Boolean,
      default: false,
    },
    update: "",
  },
  data() {
    return {
      loading: false,
      datas: null,
      selected: {},
      currentItem: {
        id: "",
        children: [],
      },
      tenantGroups: [],
      tenantGroup: {},
      defaultProps: {},
      platform: this.$root.tenantInfo.code == '1' ? 'ms' : location.pathname.replace(/\//g, "") || "pc",
    }
  },
  created() {

  },
  mounted() {
    if (this.showGroup) {
      if (localStorage.getItem("tenantGroup_" + this.$root.tenantInfo.code)) {
        this.tenantGroup = JSON.parse(localStorage.getItem("tenantGroup_" + this.$root.tenantInfo.code));
      }
      this.getTenantGroupds();
    }
    this.getDatas();
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal === "" && oldVal !== "") {
        this.currentItem = {
          id: "",
          children: [],
        };
      }
    },
    update(val) {
      if (val) {
        this.currentItem = {};
        this.getDatas();
      }
    }
  },
  methods: {
    getTenantGroupds() {
      this.loading = true;
      let params = {
        "pageIndex": 1,
        "pageSize": 100,
        "tenantCode": this.$root.tenantInfo.code,
      }
      this.https("get", this.$root.tenantInfo.code == '1' ? "/api/Tenant/GetTenantGroups" : "/api/Tenant/GetTenantGroupViewByTenantCode", params).then(res => {
        this.loading = false;
        this.tenantGroups = res.response.data || [];
        if (this.$root.tenantInfo.isLeader && !this.tenantGroup.id) {
          let data = this.tenantGroups.find(item => item.tenantCode == this.$root.tenantInfo.code) || {};
          this.tenantGroupChange(data.id);
        }
        if (!this.tenantGroup.id && this.tenantGroups.length > 0) {
          this.tenantGroupChange(this.tenantGroups[0].id);
        }
        if (this.tenantGroups.length == 0) {
          localStorage.removeItem("tenantGroup_" + this.$root.tenantInfo.code);
        }
      }).catch(res => {
        this.loading = false;
      })
    },
    tenantGroupClick(data) {
      this.tenantGroup = data;
      localStorage.setItem("tenantGroup_" + this.$root.tenantInfo.code, JSON.stringify(this.tenantGroup));
    },
    tenantGroupChange(id) {
      let data = this.tenantGroups.find(item => item.id == id);
      this.tenantGroup = data;
      localStorage.setItem("tenantGroup_" + this.$root.tenantInfo.code, JSON.stringify(this.tenantGroup));
      this.currentItem = {
        id: "",
        children: [],
      };
      this.getDatas();
    },
    getDatas() {
      if (!this.tenantGroup.id && this.showGroup) {
        return;
      }
      this.loading = true;
      var params = {
        tenantCode: this.showGroup ? this.tenantGroup.tenantCode : this.$root.tenantInfo.code,
        parentId: "0",
        type: 20,
      }
      let url = "/api/SubjectCatalogue/GetSubjectCatalogueTreeByTenantCode";
      if (this.platform == "pc") {
        url = "/api/SubjectCatalogue/GetSubjectCatalogueTreeByTeacher";
      }
      this.https("get", url, params).then(res => {
        this.loading = false;
        if (res.response) {
          this.datas = res.response.children || [];
        } else {
          this.datas = [];
        }
        if (this.platform == "pc" && !res.response) {
          this.$emit('setSubjectCatalogue');
        }
        this.updateTree();
      }).catch(res => {
        this.loading = false;
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    searchTree() {
      if (this.$refs.tree) {
        this.$refs.tree.filter(this.search)
      };
    },
    updateTree() {
      setTimeout(() => {
        this.searchTree();
      })
    },
    selectTreeItem(item) {
      this.updateTree();
      this.currentItem = item;
      this.$emit('change', this.currentItem);
    },
  }
}
</script>
<style lang="scss" scoped>
.industry-tree {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;

  .industry {
    flex-shrink: 0;
    padding: 15px 15px 5px 15px;
    height: 50px;
  }

  .tree-box {
    flex: 1;
    overflow: auto;
    padding: 15px 10px;
  }

  .tree-items {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0px 5px;
    border-radius: 0px;
    flex: 1;
    position: relative;
    height: 30px;

    .sequence {
      font-size: 13px;
    }

    &:hover {
      cursor: pointer;
      background-color: #fbfbfb;
    }

    &.active {
      background-color: #e8f8f8;
    }

    .name {
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      white-space: nowrap;
      display: inline-block;
      vertical-align: middle;
      position: absolute;
      padding-right: 20px;
    }

    .dr {
      position: absolute;
      font-size: 13px;
      padding: 0 5px;
      line-height: 20px;
      top: 50%;
      right: 0;
      transform: translate(0, -50%);

      &:hover {
        color: #04adc0;
      }

      & > i {
        position: relative;
        top: 0px;
        font-size: 14px;
      }
    }

    & > span {
      display: inline-block;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/IndustryTree.vue